import WorkTimeline from "./activities/timeline";
import MilitaryTechIcon from '@mui/icons-material/MilitaryTech';
import VerifiedIcon from '@mui/icons-material/Verified';
import VerifiedSkill from "./activities/verified-skill";

function Activities() {
  const skills = verifiedSkills.map((skill, index) => <VerifiedSkill key={index} certificateUrl={skill.url} skillName={skill.name}/>)

  return (
    <div className={'container'}>
      {/*<img className={'a-background'} alt={'Background'} src={'https://raw.githubusercontent.com/tienmanh2208/public-asset-depressed-developer/master/posts/portfolio/background-portfolio3.jpeg'}></img>*/}
      <div className={'a-group'}>
        <div className={'a-experience'}>
          <WorkTimeline />
        </div>
        <div className={'a-other-sources'}>
          <h2>Activities</h2>
          <div className={'hackerrank'}>
            <h3><MilitaryTechIcon color={'primary'}/>Hackerrank Badges</h3>
            <div className={'hackerrank-badges'}>
              <a href={'https://www.hackerrank.com/nguyentienmanh6'} target={'_blank'} rel={'noreferrer'}>
                <img src={'https://raw.githubusercontent.com/tienmanh2208/public-asset-depressed-developer/master/posts/portfolio/badge_python.png'} alt={'Badge'}/>
              </a>
              <a href={'https://www.hackerrank.com/nguyentienmanh6'} target={'_blank'} rel={'noreferrer'}>
                <img src={'https://raw.githubusercontent.com/tienmanh2208/public-asset-depressed-developer/master/posts/portfolio/badge_problem_solving.png'} alt={'Badge'}/>
              </a>
              <a href={'https://www.hackerrank.com/nguyentienmanh6'} target={'_blank'} rel={'noreferrer'}>
                <img src={'https://raw.githubusercontent.com/tienmanh2208/public-asset-depressed-developer/master/posts/portfolio/badge_sql.png'} alt={'Badge'}/>
              </a>
            </div>
            <h3><VerifiedIcon color={'primary'}/>Hackerrank Verified Skills</h3>
            <div className={'hackerrank-verified-skills'}>
              {skills}
            </div>
            <div className={'hackerrank-link'}>
              <a href={'https://www.hackerrank.com/nguyentienmanh6'} target={'_blank'} rel={'noreferrer'}>My Hackerrank Dashboard</a>
            </div>
          </div>
          <div className={'udemy'}>Udemy activities</div>
        </div>
      </div>
    </div>
  )
}

export default Activities;

const verifiedSkills: {name: string; url: string}[] = [
  {
    name: 'SQL (Advanced)',
    url: 'https://www.hackerrank.com/certificates/b32ff82541ab'
  },
  {
    name: 'Problem Solving (Basic)',
    url: 'https://www.hackerrank.com/certificates/77c6b427b6dc'
  },
  {
    name: 'Python (Basic)',
    url: 'https://www.hackerrank.com/certificates/4e98dfb460fe'
  },
  {
    name: 'Javascript (Basic)',
    url: 'https://www.hackerrank.com/certificates/1159e9b8a37a'
  },
  {
    name: 'SQL (Intermediate)',
    url: 'https://www.hackerrank.com/certificates/0277b0d5ede0'
  },
  {
    name: 'SQL (Basic)',
    url: 'https://www.hackerrank.com/certificates/2801243a8a9e'
  },
  {
    name: 'CSS',
    url: 'https://www.hackerrank.com/certificates/42b5beb05db1'
  }
]
